import React, { useState, useEffect, useMemo, useRef } from "react";
import axiosInstance from "../helpers/axiosInstance";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { FaFilter } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

const VehicleInfo = () => {
    const [vehicles, setVehicles] = useState([]);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, totalPages: 1 });
    const [loading, setLoading] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showBulkModal, setShowBulkModal] = useState(false);
    const [inputPage, setInputPage] = useState(1);


    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [truckNumber, setTruckNumber] = useState("");
    const [driverName, setDriverName] = useState("");
    const [driverMobile, setDriverMobile] = useState("");
    const [vendorCode, setVendorCode] = useState("");
    const [filteredVendors, setFilteredVendors] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [vendors, setVendors] = useState([]);
    const navigate = useNavigate();

    const [truckOptions, setTruckOptions] = useState([]);
    const [driverOptions, setDriverOptions] = useState([]);
    const [vendorOptions, setVendorOptions] = useState([]);

    const [selectedTruck, setSelectedTruck] = useState("");
    const [selectedDriver, setSelectedDriver] = useState("");
    const [selectedVendor, setSelectedVendor] = useState("");

    const [showTruckFilter, setShowTruckFilter] = useState(false);
    const [showDriverFilter, setShowDriverFilter] = useState(false);
    const [showVendorFilter, setShowVendorFilter] = useState(false);

    const [truckSearch, setTruckSearch] = useState("");
    const [driverSearch, setDriverSearch] = useState("");
    const [vendorSearch, setVendorSearch] = useState("");


    const fetchFilterOptions = async () => {
        try {
            const res = await axiosInstance.get("api/scheduled/vehicle-info", { params: { getFilters: true } });
            setTruckOptions(res.data.truckNumbers);
            setDriverOptions(res.data.driverNames);
            setVendorOptions(res.data.vendorCodes);
        } catch (err) {
            console.error("Error fetching filter options:", err);
        }
    };


    const fetchVehicles = async (page = 1, filters = {}) => {
        setLoading(true);
        try {
            const params = {
                page, limit: pagination.limit, truck_number: selectedTruck,
                driver_name: selectedDriver,
                vendor_code: selectedVendor,
            };
            const res = await axiosInstance.get("api/scheduled/vehicle-info", { params });

            setVehicles(res.data.data);
            setPagination({
                page: res.data.currentPage || page,
                limit: pagination.limit,
                totalPages: res.data.totalPages || 1,
                total: res.data.totalRecords || 0,
            });

            console.log("Vehicles:", res.data.data);
        } catch (err) {
            console.error("Error fetching vehicles:", err);
            Swal.fire(
                "Error",
                err.response?.data?.error || err.response?.data?.message || "Failed to fetch vehicles",
                "error"
            );
            setVehicles([]);
        }
        setLoading(false);
    };

    useEffect(() => {
        setInputPage(pagination.page);
    }, [pagination.page]);


    // Fetch vehicles when component mounts or page changes
    useEffect(() => {
        fetchFilterOptions();
        fetchVehicles(pagination.page);
    }, [pagination.page]);

    useEffect(() => {
        fetchVehicles(1);
    }, [selectedTruck, selectedDriver, selectedVendor]);

    const handleSelect = (type, value) => {
        if (type === "truck") setSelectedTruck(value);
        if (type === "driver") setSelectedDriver(value);
        if (type === "vendor") setSelectedVendor(value);

        // Hide dropdown and reset search
        if (type === "truck") { setShowTruckFilter(false); setTruckSearch(""); }
        if (type === "driver") { setShowDriverFilter(false); setDriverSearch(""); }
        if (type === "vendor") { setShowVendorFilter(false); setVendorSearch(""); }
    };

    const clearFilter = (type) => {
        if (type === "truck") setSelectedTruck("");
        if (type === "driver") setSelectedDriver("");
        if (type === "vendor") setSelectedVendor("");

        fetchVehicles(1);
    };

    const totalPages = pagination.totalPages || 1;
    // Change page
    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
            setPagination((prev) => ({ ...prev, page: newPage }));
            setInputPage(newPage);
        }
    };

    const handleInputChange = (e) => {
        setInputPage(e.target.value);
    };

    const handleInputSubmit = () => {
        const newPage = Number(inputPage);
        if (newPage >= 1 && newPage <= totalPages) {
            handlePageChange(newPage);
        } else {
            setInputPage(pagination.page); // reset if invalid
        }
    };

    const handleExport = async () => {
        try {
            const response = await axiosInstance.get("/api/vehicle/vehicle-export", {
                responseType: "blob", // important to receive file as blob
            });

            // Check if backend sent JSON error instead of Excel
            const contentType = response.headers["content-type"];
            if (contentType && contentType.includes("application/json")) {
                const text = await response.data.text();
                const json = JSON.parse(text);
                Swal.fire("Error!", json.error || "Something went wrong.", "error");
                return;
            }

            // Proceed with Excel download
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "VehicleInfo.xlsx");

            Swal.fire({
                icon: "success",
                title: "Export Started",
                text: "File Downloading has Started!",
                confirmButtonText: "OK",
            });
        } catch (error) {
            console.error("Export failed:", error);

            let message = "Something went wrong while exporting vehicle data.";

            // Try to extract backend error if available
            if (error.response?.data) {
                try {
                    const text = await error.response.data.text();
                    const json = JSON.parse(text);
                    message = json.error || message;
                } catch { }
            }

            Swal.fire("Error!", message, "error");
        }
    };








    useEffect(() => {
        const fetchVendors = async () => {
            try {
                const res = await axiosInstance.get("/api/vehicle/vendors");
                // Extract only vendor_code
                const codes = res.data.vendors.map(v => v.vendor_code);
                setVendors(codes);
            } catch (error) {
                console.error("Failed to fetch vendors:", error);
            }
        };
        fetchVendors();
    }, []);

    const handleFileUploadClick = () => {
        fileInputRef.current.click();
    };

    // Handle file selection
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setSelectedFile(file);
        console.log("Selected file:", file);
    };


    // Handle Upload button click
    const handleUpload = async () => {
        if (!selectedFile) return;

        try {
            const formData = new FormData();
            formData.append("file", selectedFile);

            // Call backend API
            const response = await axiosInstance.post("/api/vehicle/vehicle-upload", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            // Show success message from backend
            Swal.fire("Uploaded!", response.data.message, "success").then(() => {
                // Redirect to index page after closing the alert
                navigate("/vehicle_info"); // or your index route
            });

            // Reset file input
            fetchVehicles(pagination.page);
            setSelectedFile(null);
            fileInputRef.current.value = null;
        } catch (error) {
            console.error("Upload failed:", error);

            // Show error message
            Swal.fire(
                "Error",
                error.response?.data?.error || error.response?.data?.message || "Failed to upload file",
                "error"
            );
        }
    };


    const handleDownloadFormat = () => {
        const dummyData = [
            { sl_no: "1", truck_number: "OD02FC9886", driver_name: "Ramesh", driver_mobile_number: "9876543210", vendor_code: "A129" },
            { sl_no: "2", truck_number: "MH04AK5567", driver_name: "Suresh", driver_mobile_number: "9123456780", vendor_code: "A201" },
        ];
        const worksheet = XLSX.utils.json_to_sheet(dummyData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "VehicleFormat");
        XLSX.writeFile(workbook, "Vehicle_Format.xlsx");
    };

    const handleVendorInput = (e) => {
        const value = e.target.value;
        setVendorCode(value);

        if (value.trim().length >= 2) { // show dropdown after 2 characters
            const filtered = vendors
                .filter((v) => v && v.toLowerCase().includes(value.trim().toLowerCase()));
            setFilteredVendors(filtered);
            setShowDropdown(true); // always true if input >= 2 chars
        } else {
            setShowDropdown(false);
            setFilteredVendors([]);
        }
    };

    const handleSelectVendor = (vendor) => {
        setVendorCode(vendor);
        setShowDropdown(false);
    };

    const validateMobile = (mobile) => /^\d{10}$/.test(mobile.toString().trim());

    const handleAdd = async () => {
        // Basic frontend validation
        if (!truckNumber || !driverName || !driverMobile || !vendorCode) {
            Swal.fire("Error", "Please fill all fields", "error");
            return;
        }

        if (!validateMobile(driverMobile)) {
            Swal.fire("Error", "Driver mobile number must be 10 digits", "error");
            return;
        }

        const vehicleData = {
            truck_number: truckNumber,
            driver_name: driverName,
            driver_mobile_number: driverMobile,
            vendor_code: vendorCode,
        };

        try {
            // Send POST request to backend
            const response = await axiosInstance.post("/api/vehicle/manual-entry", vehicleData);

            // Success message
            Swal.fire("Success", response.data.message || "Vehicle added successfully", "success").then(() => {
                // Redirect to index page after closing the alert
                navigate("/vehicle_info"); // or your index route
            });

            // Reset form
            setTruckNumber("");
            setDriverName("");
            setDriverMobile("");
            setVendorCode("");
            setShowDropdown(false);

            fetchVehicles(pagination.page);

        } catch (error) {
            console.error("Add vehicle error:", error);

            // Handle backend error messages
            let message = "Failed to add vehicle";
            if (error.response?.data?.error) {
                message = error.response.data.error; // backend sends specific reason
            } else if (error.response?.data?.message) {
                message = error.response.data.message;
            }

            Swal.fire("Error", message, "error");
        }
    };

    return (
        <div className="mt-5">
            <div className="d-flex justify-content-end mb-4">
                <button
                    className="btn mx-2"
                    style={{ backgroundColor: "rgb(10, 69, 149)", color: "white" }}
                    onClick={() => setShowAddModal(true)}
                >
                    <i className="bi bi-plus-lg me-1"></i> Add
                </button>

                <button
                    className="btn"
                    style={{ backgroundColor: "rgb(10, 69, 149)", color: "white" }}
                    onClick={() => setShowBulkModal(true)}
                >
                    <i className="bi bi-people-fill me-1"></i> Add in Bulk
                </button>
                <button className="btn btn-success mx-2" onClick={handleExport}>
                    <i className="bi bi-upload me-1"></i> Export
                </button>
            </div>
            <div className="table-responsive">
                <table className="table table-sm">
                    <thead className="text-white" style={{ position: "sticky", top: 0, zIndex: 10 }}>
                        <tr>
                            <th className="text-center py-2 px-0 text-white" style={{ backgroundColor: "#0A4595", minWidth: "80px" }}>SL.No.</th>
                            <th className="text-center py-2 px-0 text-white" style={{ backgroundColor: "#0A4595", minWidth: "180px", position: "relative" }}>Truck Number
                                <FaFilter className="ms-2 cursor-pointer" onClick={() => setShowTruckFilter(!showTruckFilter)} />
                                <br />
                                {showTruckFilter && (
                                    <div className="dropdown-menu show p-2 shadow rounded"
                                        style={{ backgroundColor: "#f8f9fa", zIndex: 20, minWidth: "200px", top: "100%", left: "50%", transform: "translateX(-50%)" }}>
                                        <input type="text" placeholder="Search truck..."
                                            value={truckSearch} onChange={(e) => setTruckSearch(e.target.value)}
                                            className="form-control mb-2" style={{ fontSize: "14px", padding: "5px" }} />
                                        {truckOptions.filter(t => t.toLowerCase().includes(truckSearch.toLowerCase())).map(t => (
                                            <div key={t} className="dropdown-item px-3 py-2 text-dark" style={{ cursor: "pointer" }}
                                                onClick={() => handleSelect("truck", t)}>{t}</div>
                                        ))}
                                        {truckOptions.filter(t => t.toLowerCase().includes(truckSearch.toLowerCase())).length === 0 &&
                                            <div className="text-muted">No Trucks Found</div>}
                                    </div>
                                )}

                                {selectedTruck && (
                                    <div className="bg-light d-inline-flex align-items-center px-1 py-0 rounded mt-1" style={{ fontSize: "12px", marginLeft: "5px", color: "black" }}>
                                        {selectedTruck} <IoClose className="text-danger cursor-pointer ms-1" style={{ fontSize: "14px" }} onClick={() => clearFilter("truck")} />
                                    </div>
                                )}
                            </th>
                            <th className="text-center py-2 px-0 text-white" style={{ backgroundColor: "#0A4595", minWidth: "150px", position: "relative" }}>Driver Name
                                <FaFilter className="ms-2 cursor-pointer" onClick={() => setShowDriverFilter(!showDriverFilter)} />
                                <br />

                                {showDriverFilter && (
                                    <div className="dropdown-menu show p-2 shadow rounded"
                                        style={{ backgroundColor: "#f8f9fa", zIndex: 20, minWidth: "200px", top: "100%", left: "50%", transform: "translateX(-50%)" }}>
                                        <input type="text" placeholder="Search driver..."
                                            value={driverSearch} onChange={(e) => setDriverSearch(e.target.value)}
                                            className="form-control mb-2" style={{ fontSize: "14px", padding: "5px" }} />
                                        {driverOptions.filter(d => d.toLowerCase().includes(driverSearch.toLowerCase())).map(d => (
                                            <div key={d} className="dropdown-item px-3 py-2 text-dark" style={{ cursor: "pointer" }}
                                                onClick={() => handleSelect("driver", d)}>{d}</div>
                                        ))}
                                        {driverOptions.filter(d => d.toLowerCase().includes(driverSearch.toLowerCase())).length === 0 &&
                                            <div className="text-muted">No Drivers Found</div>}
                                    </div>
                                )}

                                {selectedDriver && (
                                    <div className="bg-light d-inline-flex align-items-center px-1 py-0 rounded mt-1" style={{ fontSize: "12px", marginLeft: "5px", color: "black" }}>
                                        {selectedDriver} <IoClose className="text-danger cursor-pointer ms-1" style={{ fontSize: "14px" }} onClick={() => clearFilter("driver")} />
                                    </div>
                                )}
                            </th>
                            <th className="text-center py-2 px-0 text-white" style={{ backgroundColor: "#0A4595", minWidth: "150px" }}>Driver Mobile Number</th>
                            <th className="text-center py-2 px-0 text-white" style={{ backgroundColor: "#0A4595", minWidth: "120px", position: "relative" }}>Vendor Code
                                <FaFilter className="ms-2 cursor-pointer" onClick={() => setShowVendorFilter(!showVendorFilter)} />
                                <br />

                                {showVendorFilter && (
                                    <div className="dropdown-menu show p-2 shadow rounded"
                                        style={{ backgroundColor: "#f8f9fa", zIndex: 20, minWidth: "200px", top: "100%", left: "50%", transform: "translateX(-50%)" }}>
                                        <input type="text" placeholder="Search vendor..."
                                            value={vendorSearch} onChange={(e) => setVendorSearch(e.target.value)}
                                            className="form-control mb-2" style={{ fontSize: "14px", padding: "5px" }} />
                                        {vendorOptions.filter(v => v.toLowerCase().includes(vendorSearch.toLowerCase())).map(v => (
                                            <div key={v} className="dropdown-item px-3 py-2 text-dark" style={{ cursor: "pointer" }}
                                                onClick={() => handleSelect("vendor", v)}>{v}</div>
                                        ))}
                                        {vendorOptions.filter(v => v.toLowerCase().includes(vendorSearch.toLowerCase())).length === 0 &&
                                            <div className="text-muted">No Vendors Found</div>}
                                    </div>
                                )}

                                {selectedVendor && (
                                    <div className="bg-light d-inline-flex align-items-center px-1 py-0 rounded mt-1" style={{ fontSize: "12px", marginLeft: "5px", color: "black" }}>
                                        {selectedVendor} <IoClose className="text-danger cursor-pointer ms-1" style={{ fontSize: "14px" }} onClick={() => clearFilter("vendor")} />
                                    </div>
                                )}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {vehicles.length > 0 ? (
                            vehicles.map((row, idx) => (
                                <tr key={idx}>
                                    <td className="text-center p-2">{(pagination.page - 1) * pagination.limit + idx + 1}</td>
                                    <td className="text-center p-2">{row.truck_number}</td>
                                    <td className="text-center p-2">{row.driver_name}</td>
                                    <td className="text-center p-2">{row.driver_mobile_number}</td>
                                    <td className="text-center p-2">{row.vendor_code}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={5} className="text-center p-2">No vehicles found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="pagination-controls d-flex justify-content-center align-items-center mt-3">
                <button
                    onClick={() => handlePageChange(pagination.page - 1)}
                    disabled={pagination.page === 1}
                    style={{ backgroundColor: "#0A4595", color: "white" }}
                    className='btn btn-sm btn-primary mx-2'
                >
                    <i className="fa fa-arrow-left"></i> Previous
                </button>

                <div className="d-flex align-items-center mx-2">
                    <span className="mx-1">Page</span>
                    <input
                        type="number"
                        value={inputPage}
                        onChange={handleInputChange}
                        onBlur={handleInputSubmit}
                        onKeyDown={(e) => e.key === "Enter" && handleInputSubmit()}
                        min={1}
                        max={totalPages}
                        style={{ width: "60px", textAlign: "center" }}
                    />
                    <span className="mx-1">of {totalPages || 1}</span>
                </div>

                <button
                    onClick={() => handlePageChange(pagination.page + 1)}
                    disabled={pagination.page === totalPages || totalPages === 0}
                    style={{ backgroundColor: "#0A4595", color: "white" }}
                    className='btn btn-sm btn-primary mx-2'
                >
                    Next <i className="fa fa-arrow-right"></i>
                </button>
            </div>


            {showAddModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                    <div
                        className="bg-white p-4 border-0 shadow-sm rounded-3"
                        style={{
                            maxWidth: "800px",
                            margin: "130px auto 0 auto",
                        }}
                    >
                        <h4 className="fw-bold text-center mb-4" style={{ color: "rgb(10, 69, 149)" }}>
                            Add Vehicle
                        </h4>

                        <div className="row g-4 mt-3">
                            <div className="col-md-6">
                                <label className="form-label fw-bold">Truck Number <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="text"
                                    className="form-control rounded-pill"
                                    placeholder="Enter Truck Number"
                                    value={truckNumber}
                                    onChange={(e) => setTruckNumber(e.target.value)}
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label fw-bold">Driver Name <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="text"
                                    className="form-control rounded-pill"
                                    placeholder="Enter Driver Name"
                                    value={driverName}
                                    onChange={(e) => setDriverName(e.target.value)}
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label fw-bold">Driver Mobile Number <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="text"
                                    className="form-control rounded-pill"
                                    placeholder="Enter Mobile Number"
                                    value={driverMobile}
                                    onChange={(e) => setDriverMobile(e.target.value)}
                                    maxLength={10}
                                />
                            </div>

                            <div className="col-md-6 position-relative">
                                <label className="form-label fw-bold">Vendor Code <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="text"
                                    className="form-control rounded-pill"
                                    placeholder="Enter Vendor Code"
                                    value={vendorCode}
                                    onChange={handleVendorInput}
                                    autoComplete="off"
                                />

                                {/* Dropdown suggestions */}
                                {showDropdown && (
                                    <ul
                                        className="list-group position-absolute w-100"
                                        style={{ zIndex: 10, maxHeight: "150px", overflowY: "auto", cursor: "pointer" }}
                                    >
                                        {filteredVendors.length > 0 ? (
                                            filteredVendors.map((v, idx) => (
                                                <li
                                                    key={idx}
                                                    className="list-group-item list-group-item-action border-0"
                                                    onClick={() => handleSelectVendor(v)}
                                                >
                                                    {v}
                                                </li>
                                            ))
                                        ) : (
                                            <li className="list-group-item border-0 text-muted" style={{ cursor: "default" }}>
                                                No vendors present
                                            </li>
                                        )}
                                    </ul>
                                )}

                            </div>

                        </div>

                        <div className="d-flex justify-content-center mt-5 gap-3">
                            <button
                                className="btn"
                                onClick={handleAdd}
                                style={{ backgroundColor: "rgb(10, 69, 149)", color: "white" }}
                            >
                                Add
                            </button>
                            <button
                                className="btn btn-secondary rounded-pill px-4"
                                onClick={() => setShowAddModal(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* -------- Add in Bulk Modal -------- */}
            {showBulkModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                    <div
                        className="d-flex flex-column align-items-center justify-content-center p-4"
                        style={{
                            borderRadius: "10px",
                            maxWidth: "600px",
                            margin: "200px auto 0 auto",
                            textAlign: "center",
                            backgroundColor: "#fafafa",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                            position: "relative",
                        }}
                    >
                        {/* ✅ Top right Download Format button */}
                        <button
                            className="btn btn-outline-primary position-absolute"
                            style={{ top: "15px", right: "20px", borderRadius: "20px", fontWeight: "500" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleDownloadFormat();
                            }}
                        >
                            <i className="bi bi-download me-2"></i> Download Format
                        </button>

                        <p className="h5 mb-2 mt-4 fw-bold" style={{ color: "#0A4595", fontWeight: "600" }}>
                            Select File Here
                        </p>

                        <p className="mb-4" style={{ color: "#6c757d", fontSize: "0.9rem" }}>
                            If you want to see which data is required, please download the format above.
                        </p>


                        {/* Hidden file input */}
                        <input
                            type="file"
                            accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                        />

                        {/* Custom file box */}
                        <div className="d-flex align-items-center" style={{ width: "50%", minWidth: "220px", maxWidth: "250px" }}>
                            {/* File box */}
                            <div
                                className="flex-grow-1 p-1"
                                style={{ backgroundColor: "#d8d8d8ff", cursor: "pointer", border: "1px solid #9e9e9eff" }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleFileUploadClick();
                                }}
                            >
                                <span className="text-truncate">
                                    Choose File
                                </span>
                            </div>

                            {/* Span outside box on the right */}
                            <span
                                className="text-muted ms-2"
                                style={{ whiteSpace: "nowrap", fontSize: "0.9rem", alignSelf: "center" }}
                            >
                                {selectedFile ? selectedFile.name : "No file choosen"}
                            </span>
                        </div>

                        {/* File supported text with red star */}
                        <p
                            className="mt-2"
                            style={{ color: "#6c757d", fontSize: "0.9rem", fontStyle: "italic" }}
                        >
                            <span style={{ color: "red" }}>*</span> Files Supported: CSV, XLS, XLSX
                        </p>

                        {/* Upload button */}
                        <div className="d-flex justify-content-center mt-3 gap-3">
                            <button
                                className="btn"
                                style={{
                                    backgroundColor: "rgb(10, 69, 149)",
                                    color: "white",
                                    fontWeight: "500",
                                    borderRadius: "6px",
                                    width: "140px",
                                }}
                                onClick={handleUpload}
                                disabled={!selectedFile} // disabled until file is selected
                            >
                                Upload
                            </button>

                            <button
                                className="btn btn-secondary"
                                style={{
                                    fontWeight: "500",
                                    borderRadius: "6px",
                                    width: "140px",
                                }}
                                onClick={() => setShowBulkModal(false)} // close modal or perform cancel action
                            >
                                Cancel
                            </button>
                        </div>

                    </div>
                </div>
            )}

            {/* Overlay background for modal */}
            {(showAddModal || showBulkModal) && (
                <div
                    className="modal-backdrop fade show"
                    onClick={() => {
                        setShowAddModal(false);
                        setShowBulkModal(false);
                    }}
                ></div>
            )}
        </div>
    )
}

export default VehicleInfo